/** Default overlay text color — matches the pre-custom-color banner UI. */
export const DEFAULT_FEATURED_BANNER_TEXT_COLOR = "#ffffff";

const HEX_COLOR = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

export function isValidFeaturedBannerTextColor(value: string): boolean {
  return HEX_COLOR.test(value.trim());
}

/** True only for #rrggbb — used while typing so #112 is not committed as #111122. */
export function isCompleteFeaturedBannerTextColor(value: string): boolean {
  return /^#([0-9a-fA-F]{6})$/.test(value.trim());
}

/** Expand #rgb → #rrggbb and lowercase. Invalid values fall back to white. */
export function normalizeFeaturedBannerTextColor(value: string | null | undefined): string {
  const trimmed = value?.trim() ?? "";
  if (!HEX_COLOR.test(trimmed)) {
    return DEFAULT_FEATURED_BANNER_TEXT_COLOR;
  }
  if (trimmed.length === 4) {
    const r = trimmed[1];
    const g = trimmed[2];
    const b = trimmed[3];
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
  }
  return trimmed.toLowerCase();
}

export function limitFeaturedBannerDescription(value: string, maxLines = 2): string {
  const lines = value.split("\n");
  if (lines.length <= maxLines) return value;
  return lines.slice(0, maxLines).join("\n");
}
